export function parseMeasurementQuantity(value: unknown): number | null {
  if (typeof value === "number") return Number.isFinite(value) && value >= 0 && value <= 1e9 ? value : null;
  let input = String(value ?? "").trim().replace(/[\s\u00a0']/g, "");
  if (!input) return null;
  if (input.includes(",") && input.includes(".")) {
    if (/^\+?\d{1,3}(?:\.\d{3})+,\d+$/.test(input)) input = input.replace(/\./g, "").replace(",", ".");
    else if (/^\+?\d{1,3}(?:,\d{3})+\.\d+$/.test(input)) input = input.replace(/,/g, "");
    else return null;
  } else input = input.replace(",", ".");
  if (!/^\+?\d+(?:\.\d+)?$/.test(input)) return null;
  const result = Number(input);
  return Number.isFinite(result) && result <= 1e9 ? result : null;
}
